import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { ORDER_TABLE_COLUMNS_NAMES } from '../../constants';
import { getIsOrderInfoLoadingSelector, getOrderInfoSelector } from '../../selectors';
import { OrderTableComponent } from '../order-table';

const OrdersInfoWrapper = ({ orderInfo, isOrderInfoLoading }) => {
	return (
		<OrderTableComponent
			rows={orderInfo}
			isTableDataLoading={isOrderInfoLoading}
			columns={ORDER_TABLE_COLUMNS_NAMES}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	orderInfo: getOrderInfoSelector(),
	isOrderInfoLoading: getIsOrderInfoLoadingSelector(),
});

OrdersInfoWrapper.propTypes = {
	orderInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			title: PropTypes.string,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
		}),
	).isRequired,
	isOrderInfoLoading: PropTypes.bool.isRequired,
};
const OrdersInfo = connect(mapStateToProps)(OrdersInfoWrapper);

export { OrdersInfo };
